import React from "react";
import styles from "./DocumentCenterSelectionBanner.module.css";
import { CustomButton, CustomIconButton, icon } from "../../../../common/components";
import { Flags, isFeatureEnabled, isSegFeatureEnabled, SegFlags, translate } from "../../../../common/providers";

const DocumentCenterSelectionBanner = ({
	selectionCount,
	onOpenDeleteDialog,
	hasInProgress,
	onOpenMoveDialog,
	hasActionPermission,
	onDownload,
	hasUnsupported,
	onOpenTypeDialog,
}) => (
	<div className={styles.container}>
		<span className={styles.actions__selection}>
			{translate(
				selectionCount === 1 ? "document-center.table.single-selection" : "document-center.table.selection",
				{ selectionCount }
			)}
		</span>
		<div className={styles.actionContainer}>
			<CustomIconButton
				btnClassName={styles.iconBtn}
				color="secondary"
				data-testid="documentCenter.downloadSelectionBtn"
				disabled={selectionCount === 0}
				icon={icon.faDownload}
				size="xs"
				tooltip={translate("document-center.table.actions.download")}
				variant="outlined"
				onClick={onDownload}
			/>
			{!hasInProgress && hasActionPermission && (
				<CustomIconButton
					btnClassName={styles.iconBtn}
					color="secondary"
					data-testid="documentCenter.moveSelectionBtn"
					disabled={selectionCount === 0}
					icon={icon.faArrowRight}
					size="xs"
					tooltip={translate("document-center.table.actions.move")}
					variant="outlined"
					onClick={onOpenMoveDialog}
				/>
			)}
			{hasActionPermission && (
				<CustomIconButton
					btnClassName={styles.iconBtn}
					color="secondary"
					data-testid="documentCenter.deleteSelectionBtn"
					disabled={selectionCount === 0}
					icon={icon.faTrash}
					size="xs"
					tooltip={translate("document-center.table.actions.delete")}
					variant="outlined"
					onClick={onOpenDeleteDialog}
				/>
			)}
			{isSegFeatureEnabled(SegFlags.DOC_TYPE_DELIVERABLE) &&
				isFeatureEnabled(Flags.WRITE_PLUGIN) &&
				!hasUnsupported && (
					<CustomButton
						className={styles.btn}
						color="secondary"
						data-testid="documentCenter.addTypeSelectionBtn"
						size="xs"
						startIcon={icon.faPlus}
						variant="outlined"
						onClick={onOpenTypeDialog}
					>
						{translate("document-center.table.actions.add-type")}
					</CustomButton>
				)}
		</div>
	</div>
);

export default DocumentCenterSelectionBanner;
